import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "text-gray-600 mt-4 text-sm whitespace-pre-line"
};
import { ref, computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSelect from '@/components/LlSelect.vue';
export default {
  __name: 'LlAssignToFixedFeeModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    fixedFeeList: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedCount: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:modelValue', 'cancel', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const selectedFixedFee = ref(null);

    // Use computed getter/setter for v-model sync
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    });

    // Confirmation message computed
    const confirmationMessage = computed(() => {
      const count = props.selectedCount;
      const entryText = `${count} ${count === 1 ? 'entry' : 'entries'}`;
      const targetName = selectedFixedFee.value?.description || 'the selected fee';
      return `Are you sure you want to reassign ${entryText} to "${targetName}"?\n\nThese entries will be removed from the current fixed fee and assigned to the selected fee.`;
    });
    const handleCancel = () => {
      selectedFixedFee.value = null;
      dialogVisible.value = false;
      emit('cancel');
    };
    const handleConfirm = () => {
      if (!selectedFixedFee.value) return;
      emit('confirm', selectedFixedFee.value);
      dialogVisible.value = false;
      selectedFixedFee.value = null;
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        "max-width": "500",
        persistent: "",
        "data-cy": "assign-to-fixed-fee-modal",
        onAfterEnter: _cache[2] || (_cache[2] = $event => selectedFixedFee.value = null)
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "headline"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("Assign to Fixed Fee", -1)]))]),
            _: 1
          })]),
          append: _withCtx(() => [_createVNode(LlSecondaryButton, {
            icon: "mdi-close",
            variant: "text",
            "aria-label": "Close dialog",
            onClick: handleCancel
          })]),
          default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("p", {
              class: "text-gray-600 mb-4"
            }, " Please select the fixed fee you wish to assign to ", -1)), _createVNode(LlSelect, {
              modelValue: selectedFixedFee.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedFixedFee.value = $event),
              items: __props.fixedFeeList,
              "item-title": "description",
              "item-value": "id",
              density: "compact",
              "return-object": "",
              clearable: true,
              loading: __props.loading,
              placeholder: "Select Fixed Fee...",
              variant: "outlined",
              "hide-details": "true",
              label: "Fixed Fee",
              labelClass: "text-sm remove-outline",
              isAutocomplete: "",
              "data-cy": "fixed-fee-select"
            }, null, 8, ["modelValue", "items", "loading"]), selectedFixedFee.value ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(confirmationMessage.value), 1)) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [_createVNode(_component_v_list_item, {
              class: "w-100"
            }, {
              prepend: _withCtx(() => [_createVNode(LlSecondaryButton, {
                class: "mr-2",
                onClick: handleCancel
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" Cancel ", -1)]))]),
                _: 1
              })]),
              append: _withCtx(() => [_createVNode(LlSecondaryButton, {
                color: "primary",
                variant: "flat",
                disabled: !selectedFixedFee.value,
                onClick: handleConfirm,
                "data-cy": "assign-to-fixed-fee-confirm"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Confirm ", -1)]))]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};